export class CompanyRole {
    constructor(public id: number, public name: string) {}
}